<template>
    <div class="page">
        <div class="public-head index-head">
            <div style="height:0.5rem">
                <div>
                  <img class="public-img" src="../assets/image/Profile/profile-icon.png">
                  <label class="profile-name">alfred24 point</label>
                </div>
                
                <div class="open-width">
                  <button class="public-head-language" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"
                    style="
                      display: flex;
                      min-width: 100px;
                      align-items: center;
                      justify-content: space-between;
                      padding-left: 15px;
                      padding-right: 15px;
                      text-wrap: nowrap;
                    "
                  >
                      <p>{{languageName}}</p>
                      <span class="caret open-width-caret"></span>
                  </button>
                <ul class="dropdown-menu public-head-language-menu" aria-labelledby="dropdownMenu1">
                    <li v-for="list in languages" @click="choiceLanguage($event)" v-bind:data-langcode="list.langcode" v-bind:key="list.langcode">
                      <a href="javascript:void(0);">{{list.name}}</a>
                    </li>
                </ul>
                </div>
                <div class="index-myprofile" @click="profile()">
                    <img src="../assets/image/index/Group 28.png">
                    <p>{{$t('index.profile')}}</p>
                    <span class="iconfont icon-arrow-right index-iconfont"></span>
                </div>
            </div>
            <div>
                <span class= "iconfont icon-home3 none"></span>
                <p class="index-p">
                    <!-- {{language === 'English' ? locationNameEn : locationName}} -->
                    {{language === 'zh' ? locationName : locationNameEn }}
                </p>
            </div>
            <div class="index-selece-code">
                <div class="index-selece">
                    <img src="../assets/image/index/123.png">
                    <input id="seleceInput" :placeholder="this.$t('index.OrderId') + this.$t('index.PhoneNumber')" type="text" @keyup.enter="search($event)">
                </div>
                <img v-on:click="barcode()" src="../assets/image/index/Component 3 – 3.png">
            </div>
            <div class="index-baikuang ">
                <div class="index-baikuang-Arriving" @click="seleceClick('Arriving')">
                    <div class="cate" :style="{margin:ArrivingStyle}">{{$t('index.Arriving')}}</div>
                    <p>{{cateData.Arriving}}</p>
                    <span v-if="cateData.unstoredCount > 0">{{cateData.unstoredCount}} {{$t('UnStored')}}</span>
                </div>
                <div class="index-baikuang-Stored" @click="seleceClick('Stored')">
                    <div class="cate">{{$t('index.Stored')}}</div>
                    <p>{{cateData.Stored}}</p>
                </div>
                <div class="index-baikuang-Collected" @click="seleceClick('Collected')">
                    <div class="cate">{{$t('index.Collected')}}</div>
                    <p>{{cateData.Collected}}</p>
                </div>
                <div class="index-baikuang-Returns" @click="seleceClick('Returns')">
                    <div class="cate">{{$t('index.Returns')}}</div>
                    <p>{{cateData.Returns}}</p>
                </div>
            </div>
        </div>
    <div class="index-body">
        <div class="index-nav " >
            <div class ="index-list index-Store-Return" @click="tiaoZhuan('collectingPointStoreExpress')">
                {{$t('index.Store')}}
            </div>
            <div class ="index-list index-Collect" @click="tiaoZhuan('checkPinCode')">
                {{$t('index.Collect')}}
            </div>
            <div class ="index-list index-Return" @click="tiaoZhuan('merchantTakeExpress')">
                {{$t('index.Courier')}}
            </div>
            <div class ="index-list index-Return-expired" @click="tiaoZhuan('collectExpiredExpress')">
                {{$t('index.expired')}}
            </div>
        </div>
    </div>
    <button class="index-body-home">Home</button>
        <bottom></bottom>
  </div>
</template>
<script>
import bottom from './Bottom.vue'
export default {
  components: {bottom},
  data () {
    console.log('window.config.VUE_APP_LANG_LIST', window.config)

    let lang = localStorage.getItem('lang') || window.config.VUE_APP_DEFAULT_LANG
    // if (lang === 'zh_HK') {
    //   this.language = '繁體中文'
    // } else if (lang) {
    //   this.language = lang
    // }
    let _lang = window.config.VUE_APP_LANG_LIST.split(';').map(x => {
      return {
        name: x.split(':')[0],
        langcode: x.split(':')[1]
      }
    }).find(x => x.langcode === lang)
    this.language = _lang.langcode
    this.languageName = _lang.name

    return {
      // languages: [
      //   {name: 'Portuguese'},
      //   {name: 'English'},
      //   {name: '繁體中文'}
      // ],
      languages: window.config.VUE_APP_LANG_LIST.split(';').map(x => {
        return {
          name: x.split(':')[0],
          langcode: x.split(':')[1]
        }
      }),
      // languageName: 'English',
      // language: 'en',
      languageName: _lang.name,
      language: _lang.langcode,
      list: [
        {name: 'Store/Return', class: 'index-Store-Return', action: 'collectingPointStoreExpress'},
        {name: 'Collect', class: 'index-Collect', action: 'checkPinCode'},
        {name: 'Return to courier', class: 'index-Return', action: 'merchantTakeExpress'},
        {name: 'Return expired', class: 'index-Return-expired', action: 'collectExpiredExpress'}],
      cateData: {
        Arriving: 0,
        Stored: 0,
        Collected: 0,
        Returns: 0,
        unstoredCount: 0
      },
      unstoredCount: 0,
      locationName: localStorage.getItem('locationName'),
      locationNameEn: localStorage.getItem('locationNameEn'),
      ArrivingStyle: '0.1rem 0 0.075rem 0 !important'
    }
  },
  methods: {
    search (e) {
      let search = e.srcElement.value
      if (search) {
        this.$router.push('/search-result?search=' + search)
      }
    },
    seleceClick (cate = null) {
      this.$router.push('/search-result?cate=' + cate)
    },
    choiceLanguage (e) {
      this.languageName = e.currentTarget.firstElementChild.innerText
      this.language = e.currentTarget.getAttribute('data-langcode')
      let lang = this.language
      this.$i18n.locale = lang
      // if (lang === '繁體中文') {
      //   lang = 'zh_HK'
      //   this.$i18n.locale = 'zh'
      // } else if (lang === 'English') {
      //   this.$i18n.locale = 'en'
      // } else {
      //   this.$i18n.locale = 'en'
      // }
      localStorage.setItem('lang', lang)
    },
    barcode () {
      this.$router.push('/barcode?action=parcelInfo')
    },
    profile () {
      this.$router.push('/profile')
    },
    getLocationName () {
      let vue = this
      let loop = setInterval(function () {
        let name = localStorage.getItem('locationName')
        if (name) {
          vue.locationName = name
          clearInterval(loop)
        }
      }, 50)
      let loopEn = setInterval(function () {
        let nameEn = localStorage.getItem('locationNameEn')
        if (nameEn) {
          vue.locationNameEn = nameEn
          clearInterval(loopEn)
        }
      }, 50)
    },
    tiaoZhuan (action) {
      switch (action) {
        case 'collectingPointStoreExpress':
          this.$router.push('/barcode?action=collectingPointStoreExpress')
          break
        case 'checkPinCode':
          this.$router.push('/return/pin')
          break
        case 'merchantTakeExpress':
          this.$router.push('/order/selectcompany?action=merchantTakeExpress')
          break
        case 'collectExpiredExpress':
          this.$router.push('/order/selectcompany?action=collectExpiredExpress')
          break
        default:
          break
          // return false
      }
      if (action == 'Return to Courier') {
        this.$router.push({name: 'SelectCompany', query: {title: e}})
      };
      if (action == 'Return expired') {
        this.$router.push({name: 'SelectCompany', query: {title: e}})
      };
      if (action == 'Collect') {
        this.$router.push({name: 'EnterPIN', query: {title: e, type: 'collect'}})
      };
    }
  },
  watch: {
    unstoredCount (val) {
      if (val > 0) {
        this.ArrivingStyle = '0.05rem 0 0 0 !important'
      } else {
        this.ArrivingStyle = '0.1rem 0 0.075rem 0 !important'
      }
    }
  },
  created () {
    this.getLocationName()
    let lang = localStorage.getItem('lang')
    // if (lang === 'zh_HK') {
    //   this.language = '繁體中文'
    // } else if (lang) {
    //   this.language = lang
    // }
    let _lang = window.config.VUE_APP_LANG_LIST.split(';').map(x => {
      return {
        name: x.split(':')[0],
        langcode: x.split(':')[1]
      }
    }).find(x => x.langcode === lang)
    this.language = _lang.langcode
    this.languageName = _lang.name

    // 初始化注入&校验时请求页面数据
    const vue = this
    this.axios({
      method: 'get',
      url: this.api.dailyStat
    }).then(function (response) {
      vue.cateData.Arriving = response.data.arrivingCount
      vue.cateData.Stored = response.data.storedCount
      vue.cateData.Collected = response.data.collectedCount
      vue.cateData.Returns = response.data.returnedCount
      vue.cateData.unstoredCount = response.data.unstoredCount
      vue.unstoredCount = response.data.unstoredCount
    }).catch(function (error) {
      // console.log(error)
    })
  }
}
</script>

<style src="../assets/css/bootstrap.css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Index.vue